const STORAGE_KEY = "pb-custom-labels";

const LABEL_COLOR_OPTIONS = [
  { id: "green", color: "#61BD4F" },
  { id: "yellow", color: "#F2D600" },
  { id: "orange", color: "#FF9F1A" },
  { id: "red", color: "#EB5A46" },
  { id: "purple", color: "#C377E0" },
  { id: "blue", color: "#0079BF" },
  { id: "pink", color: "#FF78CB" },
  { id: "sky", color: "#00C2E0" },
  { id: "lime", color: "#51E898" },
  { id: "gray", color: "#B3BAC5" },
];

const readStore = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
};

const writeStore = (store) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(store));
};

export const getLabelColorOptions = () => LABEL_COLOR_OPTIONS;

export const getCustomLabels = (boardId) => {
  if (!boardId) return [];
  const store = readStore();
  return Array.isArray(store[boardId]) ? store[boardId] : [];
};

export const findCustomLabel = (labelId, boardId) => {
  if (!labelId) return null;
  if (boardId) {
    return getCustomLabels(boardId).find((label) => label.id === labelId) || null;
  }
  const store = readStore();
  for (const labels of Object.values(store)) {
    if (!Array.isArray(labels)) continue;
    const match = labels.find((label) => label.id === labelId);
    if (match) return match;
  }
  return null;
};

export const addCustomLabel = (boardId, { name, colorId = "green" }) => {
  const trimmed = String(name || "").trim();
  if (!boardId || !trimmed) return null;

  const colorOption =
    LABEL_COLOR_OPTIONS.find((option) => option.id === colorId) || LABEL_COLOR_OPTIONS[0];
  const label = {
    id: `custom_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`,
    name: trimmed,
    color: colorOption.color,
    colorId: colorOption.id,
    custom: true,
  };

  const store = readStore();
  const existing = Array.isArray(store[boardId]) ? store[boardId] : [];
  store[boardId] = [...existing, label];
  writeStore(store);
  return label;
};
